import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import { checkIsMobile } from '@module/utils/checkIsMobile';
import TimeConstants from '@module/utils/item';
import { useEffect } from 'react';
import useGetLoginInfoQuery from '../auth/useGetLoginInfoQuery';

/**
 * [PandaTV 전용] 실버모드 사용자가 성인 방송에 진입했을 때, 본인인증/회원가입을 유도하는
 * 안내 메시지(ChatIntro)를 3초마다 채팅에 추가한다.
 *
 * playMode/siteMode는 PandaTV에만 존재하는 정책이므로 fanza에서는 호출하지 않는다.
 * (기존 useChatRoomLifecycle 내부에 있던 panda 전용 로직을 분리)
 */
function useSilverModeAdultChatGuide() {
  const $ = _c(7);
  const {
    data: playInfo
  } = useFetchLivePlayMutationStore();
  const setChatMessages = useChatMessageStore(_temp);
  const {
    isLogin,
    siteMode
  } = useGetLoginInfoQuery();
  let t0;
  if ($[0] !== isLogin || $[1] !== playInfo || $[2] !== setChatMessages || $[3] !== siteMode?.mode) {
    t0 = () => {
      if (!playInfo) {
        return;
      }
      const isSilverModeAdultBroadcast = playInfo.playMode === "adult" && siteMode?.mode === "s";
      if (!isSilverModeAdultBroadcast) {
        return;
      }
      const isMobile = checkIsMobile();
      const guidedTitle = isLogin ? "\uBCF8\uC778\uC778\uC99D" : "\uD68C\uC6D0\uAC00\uC785";
      const handleGuidedMessage = message => {
        setChatMessages(prev => [...prev, {
          data: {
            type: "ChatIntro",
            message
          },
          offset: Date.now()
        }]);
      };
      const handleGuidedMessageTimer = setInterval(() => {
        handleGuidedMessage(isMobile ? `HOT한 채팅이 진행 중입니다. \n\"${guidedTitle}\" 후 채팅 내용을 확인할 수 있습니다.` : `*****************************************\nHOT한 채팅이 진행 중입니다. \n\"${guidedTitle}\" 후 채팅 내용을 확인할 수 있습니다.\n*****************************************`);
      }, TimeConstants.ONE_SECOND * 3);
      return () => {
        clearInterval(handleGuidedMessageTimer);
      };
    };
    $[0] = isLogin;
    $[1] = playInfo;
    $[2] = setChatMessages;
    $[3] = siteMode?.mode;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== playInfo) {
    t1 = [playInfo];
    $[5] = playInfo;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  useEffect(t0, t1);
}
function _temp(state) {
  return state.setChatMessages;
}
export default useSilverModeAdultChatGuide;